import { Paper } from "@mui/material";

export default function SectionCard({ title, children, sx = {} }) {
  return (
    <Paper className="section-card" sx={{ flexDirection: "column", ...sx }}>
      {title && <p className="subtitle">{title}</p>}
      {children}
    </Paper>
  );
}
